const RealizacaoProvaList = () =>
  import("~/components/Views/Prova/Relatorio/RealizacaoProvaList");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Relatórios", link: "" }
];

export const realizacaoProva = [
  {
    path: "relatorios/realizacao-prova",
    component: RealizacaoProvaList,
    name: "Realizações de Provas",
    meta: {
      title: "Realizações de Provas",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/relatorio/realizacaoProva.js